import { useEffect, useRef, useState, type InputHTMLAttributes, type ReactNode } from 'react';
import { Icon } from '../icon/icon';
import { cn } from '@workspace/ui/lib/utils';

interface CheckBoxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: ReactNode;
  size?: '24' | '32';
  disabled?: boolean;
  containerClassName?: string;
  colorOnSelect?: string;
}

export function CheckBox({
  label,
  size = '32',
  disabled,
  containerClassName,
  colorOnSelect = 'var(--action-action-blue-default)',
  ...props
}: CheckBoxProps) {
  const [checked, setChecked] = useState(props.checked);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  return (
    <>
      <div
        onClick={() => !disabled && inputRef.current?.click()}
        className={cn('flex items-center gap-2 w-fit', containerClassName)}
      >
        <Icon
          name={disabled ? 'CircleCheckFilledDisabled' : 'CircleCheckFilled'}
          size={Number(size)}
          color={checked ? colorOnSelect : 'var(--action-action-gray-default)'}
        />
        {label && (
          <label
            className={cn(
              'text-text-default text-size-6 font-regular leading-font-height-5 tracking-[-0.1px]',
            )}
            style={{ color: disabled ? 'var(--text-text-disabled)' : 'var(--text-text-default)' }}
            draggable={false}
          >
            {label}
          </label>
        )}
      </div>
      <input
        ref={inputRef}
        type='checkbox'
        disabled={disabled}
        {...props}
        className='hidden'
        onChange={(e) => {
          setChecked(e.target.checked);
          props.onChange?.(e);
        }}
      />
    </>
  );
}
